import { Button, Typography } from 'omakase';
import { Container } from 'ui';
import { FunctionComponent } from 'react';
import { useActions } from '@tock/shared/utils/connect';
import ResponsiveCallToAction from 'components/profile/ResponsiveCallToAction';

const WelcomeNewUserSection: FunctionComponent<{}> = () => {
  const {
    actions: { patron: patronActions },
  } = useActions();
  return (
    <Container className="Welcome-wrapper">
      <div className="Welcome-section">
        <ResponsiveCallToAction
          title={<Typography variant="heading03">Welcome to your diner profile</Typography>}
          isTitle={false}
          bodyText={
            <Typography variant="body02">
              Your Tock diner profile is the perfect place to capture what defines you as a lover of
              great food experiences. Add your preferences and restrictions, your favorite dining
              cities, and your important dates.
            </Typography>
          }
          action={
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                patronActions.openEditPatronProfileModal();
                window.analytics.sendEvent(undefined, undefined, 'Setup Diner Profile');
              }}
            >
              Set up your profile
            </Button>
          }
          imageUrl="https://tock-public.imgix.net/images-profile/tock-diner-profile-nc.jpg"
          altText="Bartender preparing a cocktail by expressing the oil from a citrus peel at Gift Horse in Providence, RI"
        />
      </div>
    </Container>
  );
};

export default WelcomeNewUserSection;
